import React from "react";

const GigFinancialDataVenueCutForm = ({ venueCut, handleVenueCutFieldChange, handleVenueCutUpdate }) => {

  // const [ venueCut, setVenueCut ] = useState(0);

  return (
    <form id="updateVenueCut" className="hidden" onSubmit={handleVenueCutUpdate}>
      <h3 className="form-heading">Update venue cut</h3>

      <div>
        <label>New amount (in pence)</label>
        <input
          type="number"
          name="venueCut"
          id="venueCut"
          placeholder="eg. enter £50 as 5000"
          value={venueCut}
          onChange={handleVenueCutFieldChange}
        />
      </div>

      <div>
      <button className="form-button" type="submit">Update amount</button>
      </div>
    </form>
  )

};

export default GigFinancialDataVenueCutForm;